export const stats: [string, string][] = [
  ['10', 'COMPLETE VOLUMES'],
  ['600', 'PAGES OF CURRICULUM'],
  ['60', 'PAGES PER GRADE'],
  ['100%', 'COMMON CORE ALIGNED'],
]
